<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style>
body{
  margin:0;
  padding:0;
}
div{
    box-sizing: border-box;
}
.tip-box{
    max-width: 150px;
    position:fixed;
    top:50%;
    left:50%;
    transform: translateX(-50%) translateY(-50%);
    padding:5px 10px;
    font-size: 12px;
    color:#fff;
    background: rgba(0,0,0,0.7);
    border-radius: 3px;
}
</style>
